import ModalWrapper from 'components/ModalWrapper';
import React, { ReactElement } from 'react';
import UploadStudyForm, { IFormProps } from './UploadStudyForm';

const UploadStudyModal = (props: IFormProps): ReactElement => {
  const { onClose } = props;
  return (
    <ModalWrapper
      onClose={onClose}
      isOpen
      fullWidth={true}
      maxWidth="lg"
      sx={{
        '& .MuiDialogContent-root': {
          p: 0,
        },
      }}
    >
      <UploadStudyForm {...props} />
    </ModalWrapper>
  );
};

export default UploadStudyModal;
